import { MouseEvent } from 'react';

export function handleGaClick(
  element: MouseEvent<HTMLAnchorElement>,
  eventName: string,
  url: string,
  linkText: string,
  location: string
) {
  const w = window as any;
  if (typeof w.homePageDataPush === 'function') {
    w.homePageDataPush(eventName, url, linkText, location);
  }
}

export function trackEventDirect(category: string, action: string, label: string) {
  const w = window as any;
  if (Array.isArray(w.dataLayer)) {
    w.dataLayer.push({
      event: 'trackEvent',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventInteraction: true,
    });
  }
}

/** Dataset-driven GA for elements with data-category / data-action / data-label. */
export function trackEventFromDataset(event: MouseEvent<HTMLElement>) {
  const { category, action, label } = event.currentTarget.dataset;
  if (!category || !action || !label) {
    return;
  }
  trackEventDirect(category, action, label);
}

type GaDataAttribute = {
  dataAttributeName?: string;
  dataAttributeValue?: string;
};

type GaEventItem = {
  dataAttributes?: GaDataAttribute[];
};

/** Builder mobile-nav item shape for GA dataset props (no store imports). */
export type MobileNavGaItem = {
  dataCategory?: string;
  dataAction?: string;
  dataLabel?: string;
  gaEvents?: GaEventItem[];
};

const findGaAttributeValue = (attributes: GaDataAttribute[], name: string): string | undefined => {
  const lowerName = name.toLowerCase();
  const match = attributes.find(attr => attr.dataAttributeName?.toLowerCase() === lowerName);
  return match?.dataAttributeValue;
};

/**
 * Resolve Django-style data-category/action/label from Builder fields or gaEvents.
 * Prefers direct dataCategory fields; falls back to first gaEvents entry (Next alignment).
 */
export function getMobileNavGaProps(item?: MobileNavGaItem): Record<string, string> {
  if (!item) {
    return {};
  }

  if (item.dataCategory || item.dataAction || item.dataLabel) {
    const props: Record<string, string> = {};
    if (item.dataCategory) {
      props['data-category'] = item.dataCategory;
    }
    if (item.dataAction) {
      props['data-action'] = item.dataAction;
    }
    if (item.dataLabel) {
      props['data-label'] = item.dataLabel;
    }
    return props;
  }

  const attributes = item.gaEvents?.[0]?.dataAttributes;
  if (!attributes?.length) {
    return {};
  }

  const category = findGaAttributeValue(attributes, 'category');
  const action = findGaAttributeValue(attributes, 'action');
  const label = findGaAttributeValue(attributes, 'label');
  const props: Record<string, string> = {};

  if (category) {
    props['data-category'] = category;
    props['data-event1-category'] = category;
  }
  if (action) {
    props['data-action'] = action;
    props['data-event1-action'] = action;
  }
  if (label) {
    props['data-label'] = label;
    props['data-event1-label'] = label;
  }

  return props;
}
